// middleware/homepage.global.js
// 홈페이지(PC 웹, /homepage 하위) 전용 라우팅 조건. 앱 쪽 auth.global.js 는 이 경로를 건너뛴다.

// 비로그인 상태로 접근 가능한 홈페이지 화면
// 회원가입(인증 → 약관 → 서비스 가입)은 로그인 전에 거친다. 가입 완료 화면은 가입 후라 로그인 상태다.
// 홈·매거진은 비회원도 둘러볼 수 있다. (회원 전용 정보는 화면에서 로그인했을 때만 읽는다)
const HOMEPAGE_PUBLIC_PAGES = [
  ...HOMEPAGE_GUEST_VIEW_PAGES, // 홈·매거진 (useApi.js)
  "/homepage/login", //
  "/homepage/email-login", //
  "/homepage/phone-verify", //
  "/homepage/terms-agree", //
  "/homepage/service-signup", //
  "/homepage/account-cancellation-complete", //
];
// 해지 완료 화면은 해지로 로그인이 풀린 뒤에 보여서 공개로 둔다.

// 이미 로그인했으면 들어올 필요가 없는 화면. 홈으로 보낸다.
// 서비스 가입(service-signup)은 가입 API 가 로그인시킨 뒤 비밀번호를 설정하는 화면이라 넣지 않는다.
const HOMEPAGE_GUEST_ONLY_PAGES = [
  "/homepage/login", //
  "/homepage/email-login", //
  "/homepage/phone-verify", //
  "/homepage/terms-agree", //
];

export default defineNuxtRouteMiddleware((to, from) => {
  // 앱 화면과 홈페이지는 CSS 를 레이아웃마다 따로 불러오는데, 한 번 불러온 CSS 는 화면을 옮겨도 빠지지 않는다.
  // 둘 사이를 오갈 때(예: SNS 로그인 콜백 → 홈페이지)는 새로 불러와서 다른 쪽 CSS 가 섞이지 않게 한다.
  // 첫 진입은 from 이 시작 위치(매칭된 화면 없음)라 넘어간다. (안 그러면 새로 불러올 때마다 다시 새로 불러온다)
  const fromPage = from.matched.length > 0;
  if (import.meta.client && fromPage && isHomepagePath(to.path) !== isHomepagePath(from.path)) {
    // 로그인 콜백은 다시 돌아올 화면이 아니라 기록을 바꿔치기한다.
    const replace = appPath(from.path).startsWith("/auth/");
    return navigateTo(useRouter().resolve(to.fullPath).href, { external: true, replace });
  }

  // "/homepage/" 처럼 끝에 / 가 붙어도 같은 화면으로 본다.
  const path = appPath(to.path).replace(/(.)\/+$/, "$1");
  if (!isHomepagePath(path)) return;

  setPageLayout("homepage");

  const authState = useAuthState();
  const loggedIn = !!authState.token.value;

  if (loggedIn && HOMEPAGE_GUEST_ONLY_PAGES.includes(path)) {
    return navigateTo("/homepage", { replace: true });
  }

  if (HOMEPAGE_PUBLIC_PAGES.includes(path)) return;

  // replace 하지 않는다. 비회원이 홈·매거진에서 회원 메뉴를 누르면 보던 화면이 기록에 남아야 뒤로가기로 돌아갈 수 있다.
  if (!loggedIn) {
    return navigateTo("/homepage/login");
  }
});
